module.exports = __webpack_public_path__ + "static/media/4.76afa92c.png";